// 統一定義事件名稱，便於後續管理和使用

// 元件層級相關事件(單一輸入框操作)

/* 選取元件 */
export const EVENT_COMPONENT_SELECT = 'component:select'
/* 取消選取元件 */
export const EVENT_COMPONENT_UNSELECT = 'component:unselect'
/* 新增元件 */
export const EVENT_COMPONENT_ADD = 'component:add'
/* 調整元件形狀（如縮放、旋轉等） */
export const EVENT_COMPONENT_TRANSFORM = 'component:transform'
/* 刪除元件 */
export const EVENT_COMPONENT_DELETE = 'application:delete'
/* 複製元件 */
export const EVENT_COMPONENT_DUPLICATE = 'application:duplicate'

// 組件層級相關事件(整個畫布操作)

/* 重做上一個操作 */
export const EVENT_APPLICATION_REDO = 'application:redo'
/* 撤銷上一個操作 */
export const EVENT_APPLICATION_UNDO = 'application:undo'
/* 清空所有內容 */
export const EVENT_APPLICATION_CLEAR = 'application:clear'
